exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1dfPekctHKcgGUixmna6Hb{display:inline-block;cursor:pointer;font-size:14px;opacity:.8;line-height:100%;padding-top:2px}._1dfPekctHKcgGUixmna6Hb:hover{opacity:1}.iNu1kog6hL4teBS2_T3OP{color:#f50}.pMgIrL0NVc17TPlEGCkOh{color:#9b9797}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/Link/style.css"],"names":[],"mappings":"AAAA,yBACI,qBAAsB,AACtB,eAAgB,AAChB,eAAgB,AAChB,WAAa,AAEb,iBAAkB,AAClB,eAAiB,CACpB,AACD,+BACI,SAAW,CACd,AACD,uBACI,UAAe,CAClB,AAED,uBACI,aAAe,CAClB","file":"style.css","sourcesContent":[".link {\n    display: inline-block;\n    cursor: pointer;\n    font-size: 14px;\n    opacity: 0.8;\n\n    line-height: 100%;\n    padding-top: 2px;\n}\n.link:hover {\n    opacity: 1;\n}\n.orange {\n    color: #ff5500;\n}\n\n.gray {\n    color: #9b9797;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"link": "_1dfPekctHKcgGUixmna6Hb",
	"orange": "iNu1kog6hL4teBS2_T3OP",
	"gray": "pMgIrL0NVc17TPlEGCkOh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/Link/style.css
// module id = 651
// module chunks = 0 1 2 3 15 16 25 26